import { AxiosResponse } from "axios";
import ApiConstants from "../../../../core/constants/api_constants";
import { request } from "../../../../core/network/axiosInstance";


export class SessionApiService {
    private readonly sessionBaseUrl: string;

    constructor() {
        this.sessionBaseUrl = ApiConstants().session;
    }

    async getIncomingSession(skip: number, limit: number): Promise<AxiosResponse> {
        const response = await request({
            method: "GET",
            url: `${this.sessionBaseUrl}incoming`,
            requiresToken: true,
            params: {
                skip,
                limit       
            }   
        });
        return response;
    }
} 